import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Avatar, Button, Stack, Tooltip} from '@mui/material';
import {
  InsertDriveFile,
  SearchOutlined,
  UploadFileOutlined,
} from '@mui/icons-material';
import 'moment/locale/id';
import {useNavigate} from 'react-router-dom';
import {ButtonContained} from 'shared/components/Button';
import DialogListApprovalSK from '../../../Dialog/DialogListApprovalSK';
import {useSelector} from 'react-redux';
import {StyledTableCell, StyledTableRow} from 'shared/components/Table';
import moment from 'moment';

const ListViewItem = ({
  key,
  index,
  id,
  data,
  receivers,
  selectedRow,
  setSelectedRow,
  handleUpload,
  handleShowAttachment,
  no,
  canBulkApprove,
}) => {
  const navigation = useNavigate();
  const {filter} = useSelector((state) => state.digiSign);
  const [open, setOpen] = useState(false);

  const handleCheckbox = (params,data ) => {
    const extRow = [...selectedRow];
    const idx = extRow.findIndex((x) => x === data.id);

    if (idx > -1 && !params.target.checked) extRow.splice(idx, 1);
    else extRow.push(data.id);
    setSelectedRow(extRow);

    console.log(extRow);
  };

  const handleGetDetail = (e, data) => {
    e.stopPropagation();
    if (
      filter === 'composer' ||
      filter === 'pk-need-sign' ||
      filter === 'pk-need-approval' ||
      data.state === 'in_progress' ||
      data.state === 'need_sign' ||
      data.state === 'need_approval' ||
      data.state === 'done' ||
      data.state === 'reject'
    ) {
      navigation('/apps/dokumen-pk/detail/' + id);
    } else {
      navigation('/apps/dokumen-pk/tambah-dokumen/' + id);
    }
  };

  return (
    <>
      <StyledTableRow key={key}>
       {filter === 'pk-need-sign' && data && canBulkApprove && <StyledTableCell align='center'>
          <input onChange={(e) => handleCheckbox(e, data)} type='checkbox'   value={data.id}          checked={selectedRow.includes(data.id)} />
        </StyledTableCell>}
        <StyledTableCell align='center'>
          {no < 1 ? index + 1 : index < 9 ? `${no}${index + 1}` : `${no + 1}0`}
        </StyledTableCell>
        <StyledTableCell align='center'>
          {data.extra_attributes?.noDokumen}
        </StyledTableCell>
        <StyledTableCell align='left'>{data.subject}</StyledTableCell>
        <StyledTableCell align='center'>
          {data.extra_attributes?.tugas}
        </StyledTableCell>
        <StyledTableCell align='center'>
          {data.receivers !== null ? data.receivers[0]?.nama : '-'}
        </StyledTableCell>
        <StyledTableCell align='center'>
          {moment(data.extra_attributes?.tanggalDokumen).format('DD/MM/YYYY')}
        </StyledTableCell>
        <StyledTableCell align='center'>
          {data.extra_attributes?.status}
        </StyledTableCell>

          <StyledTableCell align='center'>
            {data.attachments.length > 0 ? (
              <Tooltip title={'Lihat Dokumen'} placement='top' arrow>
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShowAttachment(index);
                  }}
                  style={{
                    minWidth: '30px',
                    backgroundColor: 'darkgrey',
                    marginRight: '5px',
                  }}
                >
                  <InsertDriveFile sx={{fontSize: '14px', color: 'white'}} />
                </Button>
              </Tooltip>
            ) : (
              ''
            )}

           

            {filter === 'draft' ? (
              <Tooltip title={'Edit Draft'} placement='top' arrow>
                <Button
                              onClick={(e) => handleGetDetail(e, data)}

                  style={{
                    minWidth: '30px',
                    backgroundColor: 'darkgrey',
                    marginRight: '5px',
                  }}
                >
                  <UploadFileOutlined sx={{fontSize: '14px', color: 'white'}} />
                </Button>
              </Tooltip>
            ) : (
              <Tooltip title={'Detail Dokumen'} placement='top' arrow>
              <Button
                onClick={(e) => handleGetDetail(e, data)}
                style={{
                  minWidth: '30px',
                  backgroundColor: 'darkgrey',
                  marginRight: '5px',
                }}
              >
                <SearchOutlined sx={{fontSize: '14px', color: 'white'}} />
              </Button>
            </Tooltip>
            )}
          </StyledTableCell>
      </StyledTableRow>

      <DialogListApprovalSK
        open={open}
        data={data}
        title={'Detail Penanggung Jawab'}
        handleClose={() => setOpen(false)}
      />
    </>
  );
};

export default ListViewItem;
ListViewItem.propTypes = {
  no: PropTypes.number,
  lists: PropTypes.array,
  index: PropTypes.number,
  selectedRow: PropTypes.array,
  setSelectedRow: PropTypes.func,
  handleShowAttachment: PropTypes.func,
  handleUpload: PropTypes.func,
  receivers: PropTypes.string,
  key: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  canBulkApprove: PropTypes.bool,
};
